{
  "settings.common.pageSize": "每页条数",
  "settings.common.pageSizeOption": "每页 {count} 条",
  "settings.teams.detail.description": "查看客服组信息，维护组内成员与职责。",
  "settings.teams.editAria": "编辑 {name}",
  "settings.teams.toggleActiveAria": "启用或停用 {name}",
  "settings.teams.memberRoleLabel": "组内角色",
  "settings.agents.table.name": "成员",
  "settings.agents.detail.description": "查看并维护该成员的业务资料、准入状态与全局权限。",
  "settings.teams.editMemberProfileAria": "编辑 {name} 的资料",
  "settings.routing.summary.label": "匹配条件 → 分派结果",
  "settings.routing.summary.matchAll": "同时满足",
  "settings.routing.summary.unrestricted": "其他条件不限",
  "settings.routing.summary.project": "项目：{name}",
  "settings.routing.summary.category": "分类：{name}",
  "settings.routing.summary.channel": "渠道：{name}",
  "settings.routing.summary.to": "分派到",
  "settings.routing.preview.title": "规则预览",
  "settings.routing.preview.enabled": "保存后启用，参与新工单路由。",
  "settings.routing.preview.disabled": "保存后保持停用，不参与新工单路由。",
  "settings.routing.preview.scope": "仅检查已加载的 {count} 条规则，不代表实际工单命中结果。",
  "settings.routing.preview.sameCriteria": "与优先级 {priorities} 的规则具有相同基础条件，请检查分派目标与执行顺序。",
  "settings.routing.preview.samePriority": "优先级 {priority} 已被其他规则使用；同优先级按规则 ID 排序。",
  "settings.routing.preview.categoryCleared": "已清除与所选项目不兼容的分类，请重新选择。",
  "settings.routing.preview.projectSelected": "目标项目组只接收 {project} 的工单，已自动选择该项目。",
  "settings.routing.copy.action": "以此创建规则",
  "settings.routing.copy.title": "以现有规则创建",
  "settings.routing.copy.description": "已复制优先级 {sourcePriority} 规则的条件和目标，新优先级为 {priority}，默认停用。保存前请检查。",
  "settings.common.unsavedChanges": "有未保存的更改",
  "settings.agents.revokeRoleDialog.title": "撤销 {name} 的{role}角色？",
  "settings.agents.revokeRoleDialog.description": "撤销后，该成员将失去此角色授予的权限。若这是其最后一项权限，可能无法继续使用工作台。",
  "settings.agents.revokeRoleDialog.confirm": "撤销角色",
  "settings.navigation.ticketing": "工单配置",
  "settings.navigation.operations": "组织与智能",
  "settings.common.unsaved.title": "放弃未保存的更改？",
  "settings.common.unsaved.description": "你有尚未保存的更改。离开后，这些更改将丢失。",
  "settings.common.unsaved.discard": "放弃更改并离开",
  "settings.common.unsaved.keepEditing": "继续编辑",
  "settings.common.saving": "正在保存…",
  "settings.common.savingDescription": "请等待当前操作完成后再离开，以免无法确认保存结果。",
  "settings.common.saved": "所有更改已保存",
  "settings.common.discardChanges": "取消更改",
  "settings.common.readOnly": "你只有查看权限，无法修改此配置。",
  "settings.common.referenceUnavailable": "部分关联资料不可用。请检查权限或刷新后重试，相关编辑操作暂不可用。",
  "settings.routing.disableDialog.title": "停用优先级 {priority} 的规则？",
  "settings.routing.disableDialog.description": "停用后，新工单将不再经过这条路由规则。你可以随时重新启用。",
  "settings.projects.disableDialog.title": "停用项目「{name}」？",
  "settings.projects.disableDialog.description": "停用后，该项目不再接收新工单，已有工单保持不变。你可以随时重新启用。",
  "settings.teams.removeMemberDialog.title": "移除成员 {name}？",
  "settings.teams.removeMemberDialog.description": "将 {name} 从 {team} 中移除，不会删除其工作台账号。",
  "settings.teams.removeMemberDialog.confirm": "移除成员",
  "settings.common.cancel": "取消",
  "settings.common.save": "保存",
  "settings.common.add": "添加",
  "settings.common.edit": "编辑",
  "settings.common.delete": "删除",
  "settings.common.actions": "操作",
  "settings.common.refresh": "刷新",
  "settings.common.retry": "重试",
  "settings.common.clearFilters": "清除筛选",
  "settings.common.enable": "启用",
  "settings.common.disable": "停用",
  "settings.common.notSet": "未设置",
  "settings.common.disabledSuffix": "（已停用）",
  "settings.common.status.label": "状态",
  "settings.common.status.all": "全部状态",
  "settings.common.status.enabled": "已启用",
  "settings.common.status.disabled": "已停用",
  "settings.common.middleDotSeparator": " · ",
  "settings.common.listSeparator": "；",

  "settings.projects.title": "项目",
  "settings.projects.description": "管理服务项目及其基础设置。项目按层级组织，停用后不再接收新工单。",
  "settings.projects.new": "新建项目",
  "settings.projects.create": "创建项目",
  "settings.projects.refreshing": "正在刷新项目",
  "settings.projects.loading": "正在加载项目…",
  "settings.projects.saving": "正在保存项目",
  "settings.projects.searchAria": "搜索项目",
  "settings.projects.searchPlaceholder": "搜索项目名称或代码…",
  "settings.projects.column.project": "项目",
  "settings.projects.column.code": "项目代码",
  "settings.projects.hierarchyContextOnly": "仅用于交代层级，本身不满足当前筛选条件",
  "settings.projects.enableAria": "启用项目 {name}",
  "settings.projects.disableAria": "停用项目 {name}",
  "settings.projects.actionsAria": "{name} 操作",
  "settings.projects.empty.title": "还没有项目",
  "settings.projects.empty.description": "新建项目后，工单和分类就能挂到它下面。",
  "settings.projects.empty.filteredTitle": "没有符合条件的项目",
  "settings.projects.empty.filteredDescription": "调整搜索关键词或状态筛选后再试。",
  "settings.projects.count.total": "共 {count} 个项目",
  "settings.projects.count.filtered": "匹配 {matched} 个项目，共 {total} 个",
  "settings.projects.deleteDialog.title": "删除项目「{name}」？",
  "settings.projects.deleteDialog.description": "删除后不可恢复，它的下级项目会变成顶级项目。如果只是暂时停用，用列表里的开关停用即可。",
  "settings.projects.form.editTitle": "编辑项目",
  "settings.projects.form.createTitle": "新建项目",
  "settings.projects.form.editDescription": "修改项目的代码、名称与所属上级。",
  "settings.projects.form.createDescription": "项目用于归类工单与分类，可以按层级组织。",
  "settings.projects.form.codeLabel": "项目代码",
  "settings.projects.form.codePlaceholder": "例如 PAY-CORE",
  "settings.projects.form.codeDescription": "全局唯一，用于工单编号与对外接口引用。",
  "settings.projects.form.nameLabel": "项目名称",
  "settings.projects.form.namePlaceholder": "例如 支付中台",
  "settings.projects.form.parentLabel": "上级项目",
  "settings.projects.form.parentValue": "{name}（{code}）",
  "settings.projects.form.noParent": "无（顶级项目）",
  "settings.projects.form.parentEditDescription": "自身及其下级不会出现在选项里。",
  "settings.projects.form.parentCreateDescription": "留空则创建为顶级项目。",
  "settings.projects.validation.codeRequired": "请填写项目代码。",
  "settings.projects.validation.codeMax": "项目代码不能超过 {max} 个字符。",
  "settings.projects.validation.nameRequired": "请填写项目名称。",
  "settings.projects.validation.nameMax": "项目名称不能超过 {max} 个字符。",
  "settings.projects.toast.created": "项目「{name}」已创建",
  "settings.projects.toast.saved": "项目「{name}」已保存",
  "settings.projects.toast.enabled": "项目「{name}」已启用",
  "settings.projects.toast.disabled": "项目「{name}」已停用",
  "settings.projects.toast.deleted": "项目「{name}」已删除",

  "settings.categories.title": "工单分类",
  "settings.categories.description": "按项目和层级维护分类，让人工处理、路由与智能分类使用同一套结构。",
  "settings.categories.new": "新建分类",
  "settings.categories.create": "创建分类",
  "settings.categories.delete": "删除分类",
  "settings.categories.refreshing": "正在刷新分类",
  "settings.categories.loading": "正在读取工单分类…",
  "settings.categories.saving": "正在保存分类",
  "settings.categories.deleting": "正在删除分类",
  "settings.categories.searchAria": "搜索工单分类",
  "settings.categories.searchPlaceholder": "搜索名称或路径…",
  "settings.categories.metric.categories": "个分类",
  "settings.categories.metric.global": "个通用分类",
  "settings.categories.metric.projects": "个项目已配置",
  "settings.categories.empty.title": "还没有工单分类",
  "settings.categories.empty.description": "先创建通用分类，或为某个项目建立专属分类结构。",
  "settings.categories.empty.filtered": "没有符合条件的分类。",
  "settings.categories.scopeLabel": "适用范围",
  "settings.categories.scope.all": "全部适用范围",
  "settings.categories.scope.global": "跨项目通用",
  "settings.categories.parentLabel": "上级分类",
  "settings.categories.childrenLabel": "下级分类",
  "settings.categories.projectUnavailable": "项目资料暂不可用",
  "settings.categories.projectUnknown": "未识别项目",
  "settings.categories.projectDisabled": "{name}（已停用）",
  "settings.categories.addChild": "添加下级",
  "settings.categories.editAria": "编辑 {name}",
  "settings.categories.deleteAria": "删除 {name}",
  "settings.categories.deleteBlocked": "请先移动或删除下级分类",
  "settings.categories.noParentDetail": "无，当前为一级分类",
  "settings.categories.childrenCount": "{count} 个，已在左侧展开",
  "settings.categories.noChildren": "暂无下级分类",
  "settings.categories.deleteChildrenHint": "删除当前分类前，需要先移动或删除它的下级分类。",
  "settings.categories.selectHint": "从左侧选择一个分类查看详情。",
  "settings.categories.expandAria": "展开 {name}",
  "settings.categories.collapseAria": "收起 {name}",
  "settings.categories.deleteDialog.title": "删除分类“{name}”？",
  "settings.categories.deleteDialog.description": "删除后无法恢复。如果这个分类仍被工单或路由规则引用，系统会拒绝删除，请先调整相关配置。",
  "settings.categories.form.editTitle": "编辑分类",
  "settings.categories.form.createTitle": "新建分类",
  "settings.categories.form.description": "设置分类的适用项目和层级位置，完整路径会由系统自动维护。",
  "settings.categories.form.nameLabel": "分类名称",
  "settings.categories.form.namePlaceholder": "例如 退款进度",
  "settings.categories.form.currentProjectUnavailable": "当前项目（资料暂不可用）",
  "settings.categories.form.scopeDescription": "通用分类可用于所有项目；项目分类只会出现在对应项目中。",
  "settings.categories.form.noParent": "无上级，作为一级分类",
  "settings.categories.defaultPriorityLabel": "默认优先级",
  "settings.categories.form.inheritPriority": "继承上级",
  "settings.categories.form.defaultPriorityDescription": "仅用于新建工单未明确指定优先级时，已有工单不受影响。",
  "settings.categories.form.inheritedPriority": "当前继承值：{priority}。",
  "settings.categories.form.globalPriority": "一级分类未配置时使用全局默认：{priority}。",
  "settings.categories.inheritedPriorityDetail": "继承上级（{priority}）",
  "settings.categories.globalPriorityDetail": "全局默认（{priority}）",
  "settings.categories.table.name": "分类名称",
  "settings.categories.table.scope": "适用范围",
  "settings.categories.table.defaultPriority": "默认优先级",
  "settings.categories.table.actions": "操作",
  "settings.categories.addChildAria": "为 {name} 添加下级",
  "settings.categories.table.childrenCount": "{count} 个下级",
  "settings.categories.searchExpandedHint": "搜索期间已展开匹配分类的上级。",
  "settings.categories.form.moveDescendants": "修改适用范围或上级后，{count} 个下级分类会随当前分类一起移动。",
  "settings.categories.validation.nameRequired": "请填写分类名称。",
  "settings.categories.validation.nameMax": "名称不能超过 {max} 个字符。",
  "settings.categories.toast.created": "分类「{name}」已创建",
  "settings.categories.toast.saved": "分类「{name}」已保存",
  "settings.categories.toast.deleted": "分类「{name}」已删除",

  "settings.routing.title": "路由规则",
  "settings.routing.description": "按优先级匹配新工单并分派到客服组；数字越小越先执行，命中第一条后停止。",
  "settings.routing.new": "新建规则",
  "settings.routing.create": "创建规则",
  "settings.routing.delete": "删除规则",
  "settings.routing.refreshing": "正在刷新路由规则",
  "settings.routing.loading": "正在读取路由规则…",
  "settings.routing.saving": "正在保存规则",
  "settings.routing.deleting": "正在删除规则",
  "settings.routing.searchAria": "搜索路由规则",
  "settings.routing.searchPlaceholder": "搜索条件或客服组…",
  "settings.routing.metric.rules": "条规则",
  "settings.routing.metric.enabled": "条已启用",
  "settings.routing.metric.fallback": "条兜底规则",
  "settings.routing.empty.title": "还没有路由规则",
  "settings.routing.empty.description": "新建规则后，符合条件的新工单会自动进入指定客服组。",
  "settings.routing.empty.filtered": "没有符合条件的规则。",
  "settings.routing.visibleCount": "显示 {count} 条 · 按优先级从小到大执行",
  "settings.routing.column.priority": "优先级",
  "settings.routing.column.criteria": "匹配条件",
  "settings.routing.column.assignment": "分派到",
  "settings.routing.project.all": "全部项目",
  "settings.routing.project.unscoped": "未限定项目",
  "settings.routing.project.any": "不限项目",
  "settings.routing.project.unknown": "未知项目",
  "settings.routing.category.any": "不限分类",
  "settings.routing.category.unknown": "未知分类",
  "settings.routing.channel.any": "不限渠道",
  "settings.routing.channel.unknown": "未知渠道",
  "settings.routing.channel.web": "网页",
  "settings.routing.channel.phone": "电话",
  "settings.routing.channel.api": "API",
  "settings.routing.team.unknown": "未知客服组",
  "settings.routing.criteria.whenProject": "当项目为",
  "settings.routing.criteria.whenCategory": "当分类为",
  "settings.routing.criteria.whenChannel": "当渠道为",
  "settings.routing.criteria.andMatches": "并满足",
  "settings.routing.criteria.advanced": "扩展条件",
  "settings.routing.criteria.allNewTickets": "所有新工单",
  "settings.routing.warning.teamMissing": "目标客服组不存在",
  "settings.routing.warning.teamDisabled": "目标客服组已停用，规则会被跳过",
  "settings.routing.warning.scopeMismatch": "目标客服组与规则项目范围不一致",
  "settings.routing.warning.advanced": "含扩展条件，请确认后端匹配器",
  "settings.routing.editAria": "编辑规则",
  "settings.routing.deleteAria": "删除规则",
  "settings.routing.deleteDialog.title": "删除优先级 {priority} 的规则？",
  "settings.routing.deleteDialog.description": "删除后无法恢复，之后创建的新工单将不再经过这条路由规则。",
  "settings.routing.form.editTitle": "编辑路由规则",
  "settings.routing.form.createTitle": "新建路由规则",
  "settings.routing.form.description": "工单需要同时满足所选条件；系统按优先级从小到大执行，命中第一条后停止。",
  "settings.routing.form.criteriaTitle": "匹配条件",
  "settings.routing.form.criteriaDescription": "留空的条件表示不限制该维度。",
  "settings.routing.form.channelLabel": "来源渠道",
  "settings.routing.form.priorityDescription": "数字越小越先执行，可使用 10、20、30 为后续插入规则留出空间。",
  "settings.routing.form.resultTitle": "分派结果",
  "settings.routing.form.resultDescription": "项目组只能接收自身项目的工单，职能组可以跨项目处理。",
  "settings.routing.form.teamLabel": "目标客服组",
  "settings.routing.form.teamPlaceholder": "选择客服组",
  "settings.routing.form.categoryProjectSuffix": " · {project}",
  "settings.routing.form.teamProjectSuffix": " · {project}",
  "settings.routing.form.teamFunctionalSuffix": " · 职能组",
  "settings.routing.form.disabledTeamDescription": "这个客服组已停用，启用规则后仍会被路由引擎跳过。",
  "settings.routing.form.enableImmediately": "立即启用",
  "settings.routing.form.advancedTitle": "高级条件（JSON）",
  "settings.routing.form.jsonLabel": "条件 JSON",
  "settings.routing.form.jsonPlaceholder": "例如 {\"country\":\"ZM\"}",
  "settings.routing.form.jsonDescription": "空值或 {} 表示无额外条件。",
  "settings.routing.form.advancedWarning": "当前基础匹配器不会命中非空扩展条件；请确认后端已经接入对应条件匹配器。",
  "settings.routing.validation.priority": "优先级必须是大于或等于 0 的整数。",
  "settings.routing.validation.teamRequired": "请选择工单要分派到的客服组。",
  "settings.routing.validation.scopeMismatch": "这个项目组不能接收当前规则范围内的工单。",
  "settings.routing.validation.json": "请输入有效的 JSON。",
  "settings.routing.toast.created": "优先级 {priority} 的路由规则已创建",
  "settings.routing.toast.saved": "优先级 {priority} 的路由规则已保存",
  "settings.routing.toast.enabled": "优先级 {priority} 的规则已启用",
  "settings.routing.toast.disabled": "优先级 {priority} 的规则已停用",
  "settings.routing.toast.deleted": "优先级 {priority} 的路由规则已删除",

  "settings.organization.title": "客服组和成员",
  "settings.organization.description": "在一个工作区内维护客服组的服务范围、人员编排，以及系统成员的资料与权限。",
  "settings.organization.identityUnavailable": "未提供登录名",
  "settings.organization.assignmentPolicy.roundRobin.label": "轮询分派",
  "settings.organization.assignmentPolicy.roundRobin.description": "按顺序在组内成员之间自动分配。",
  "settings.organization.assignmentPolicy.manual.label": "手动分派",
  "settings.organization.assignmentPolicy.manual.description": "由组长或管理员选择具体跟进人。",
  "settings.organization.assignmentPolicy.claim.label": "主动认领",
  "settings.organization.assignmentPolicy.claim.description": "工单进入组后，由成员自行认领。",
  "settings.organization.assignmentPolicy.unknown": "未知策略",
  "settings.organization.scope.functional.label": "职能组",
  "settings.organization.scope.functional.description": "跨项目承接特定职能的工单。",
  "settings.organization.scope.project.label": "项目组",
  "settings.organization.scope.project.description": "只服务一个指定项目。",
  "settings.organization.membershipRole.member": "成员",
  "settings.organization.membershipRole.lead": "组长",
  "settings.organization.role.unknown": "未知角色",
  "settings.organization.globalRole.admin.label": "管理员",
  "settings.organization.globalRole.admin.description": "管理系统配置、工单、客服组与成员。",
  "settings.organization.globalRole.viewer.label": "报表查看者",
  "settings.organization.globalRole.viewer.description": "查看概览与报表，不参与工单处理。",
  "settings.organization.globalRole.scopeAll.label": "全局工单可见",
  "settings.organization.globalRole.scopeAll.description": "可查看全部客服组的工单，不附带管理权限。",

  "settings.teams.title": "客服组",
  "settings.teams.description": "组织一线支持力量，明确每个组服务的项目范围、分派方式与组内职责。",
  "settings.teams.new": "新建客服组",
  "settings.teams.create": "创建客服组",
  "settings.teams.delete": "删除客服组",
  "settings.teams.refreshing": "正在刷新客服组",
  "settings.teams.loading": "正在读取客服组…",
  "settings.teams.saving": "正在保存客服组",
  "settings.teams.searchAria": "搜索客服组",
  "settings.teams.searchPlaceholder": "搜索客服组…",
  "settings.teams.metric.teams": "个客服组",
  "settings.teams.metric.active": "个正在运行",
  "settings.teams.metric.members": "名已编组成员",
  "settings.teams.status.running": "正在运行",
  "settings.teams.scope.all": "全部范围",
  "settings.teams.scope.crossProjectFunctional": "跨项目职能组",
  "settings.teams.scope.projectMissing": "项目范围未找到",
  "settings.teams.scope.disabledProject": "{name}（项目已停用）",
  "settings.teams.memberCount": "{count} 人",
  "settings.teams.empty.title": "还没有客服组",
  "settings.teams.empty.description": "先建立一个客服组，再从系统已开通成员中选择人员加入。",
  "settings.teams.empty.filtered": "没有符合条件的客服组。",
  "settings.teams.teamDisabled": "组已停用",
  "settings.teams.deleteAria": "删除 {name}",
  "settings.teams.membersTitle": "组内成员",
  "settings.teams.membersDescription": "组长可以分派工单和维护参与人，成员负责日常处理。",
  "settings.teams.addMember": "添加成员",
  "settings.teams.memberUnknown": "未知成员",
  "settings.teams.memberProfileUnavailable": "成员资料暂不可用",
  "settings.teams.updatingMemberRole": "正在更新 {name} 的角色",
  "settings.teams.removeMemberAria": "移除 {name}",
  "settings.teams.removingMember": "正在移除成员",
  "settings.teams.membersEmpty.title": "这个客服组还没有成员",
  "settings.teams.membersEmpty.description": "添加成员后，组内角色会立即参与权限计算。",
  "settings.teams.deleteDialog.title": "删除客服组「{name}」？",
  "settings.teams.deleteDialog.description": "组内成员不会被删除，但所有组内角色会一并移除。若只是暂停接收新工单，建议改为停用。",
  "settings.teams.form.editTitle": "编辑客服组",
  "settings.teams.form.createTitle": "新建客服组",
  "settings.teams.form.description": "定义这个组服务的范围，以及新工单进入后的分派方式。",
  "settings.teams.form.nameLabel": "客服组名称",
  "settings.teams.form.namePlaceholder": "例如 支付支持组",
  "settings.teams.form.scopeLabel": "服务范围",
  "settings.teams.form.projectLabel": "所属项目",
  "settings.teams.form.projectPlaceholder": "选择项目",
  "settings.teams.form.assignmentPolicyLabel": "分派方式",
  "settings.teams.validation.nameRequired": "请填写客服组名称。",
  "settings.teams.validation.nameMax": "名称不能超过 {max} 个字符。",
  "settings.teams.validation.projectRequired": "请选择客服组服务的项目。",
  "settings.teams.memberPicker.title": "添加组内成员",
  "settings.teams.memberPicker.description": "从已加入系统的成员中选择人员加入「{team}」。如需新增人员，请先在“成员”Tab 中从 IAM 开通。",
  "settings.teams.memberPicker.roleLabel": "加入后的角色",
  "settings.teams.memberPicker.roleDescription": "可稍后在组内成员列表中调整。",
  "settings.teams.memberPicker.searchAria": "搜索系统成员",
  "settings.teams.memberPicker.searchPlaceholder": "搜索姓名、邮箱或技能…",
  "settings.teams.memberPicker.loading": "正在读取系统成员…",
  "settings.teams.memberPicker.errorTitle": "系统成员加载失败",
  "settings.teams.memberPicker.errorDescription": "请检查网络后重试。",
  "settings.teams.memberPicker.adding": "正在添加系统成员",
  "settings.teams.memberPicker.alreadyAdded": "已在组内",
  "settings.teams.memberPicker.noMatches": "没有符合条件的系统成员。",
  "settings.teams.memberPicker.noAgents": "系统中还没有成员，请先在“成员”Tab 中开通。",
  "settings.teams.toast.created": "客服组「{name}」已创建",
  "settings.teams.toast.saved": "客服组「{name}」已保存",
  "settings.teams.toast.enabled": "客服组「{name}」已启用",
  "settings.teams.toast.disabled": "客服组「{name}」已停用",
  "settings.teams.toast.deleted": "客服组「{name}」已删除",
  "settings.teams.toast.memberAdded": "{name} 已加入「{team}」",
  "settings.teams.toast.memberRoleUpdated": "{name} 的组内角色已更新",
  "settings.teams.toast.memberRemoved": "{name} 已从「{team}」移除",

  "settings.agents.title": "成员",
  "settings.agents.description": "维护已开通人员的客服属性、准入状态与全局权限；姓名、邮箱和头像始终以 IAM 为准。",
  "settings.agents.provisionFromIam": "从 IAM 开通成员",
  "settings.agents.provisionFromIamShort": "从 IAM 开通",
  "settings.agents.refreshing": "正在刷新客服",
  "settings.agents.loading": "正在读取成员…",
  "settings.agents.updatingStatus": "正在更新客服状态",
  "settings.agents.metric.provisioned": "名已开通成员",
  "settings.agents.metric.active": "名当前可登录",
  "settings.agents.metric.unassigned": "名尚未编组",
  "settings.agents.empty.title": "还没有已开通成员",
  "settings.agents.empty.description": "从 IAM 员工目录开通人员，再为其分配客服组或全局角色。",
  "settings.agents.empty.filtered": "没有符合条件的成员。",
  "settings.agents.searchAria": "搜索成员",
  "settings.agents.searchPlaceholder": "姓名、邮箱或技能…",
  "settings.agents.status.canSignIn": "可登录",
  "settings.agents.status.workspaceAccess": "可登录工作台",
  "settings.agents.status.noWorkspaceAccess": "已停用，无法登录",
  "settings.agents.roleFilter.all": "全部全局角色",
  "settings.agents.roleFilter.none": "无全局角色",
  "settings.agents.currentAccount": "当前账号",
  "settings.agents.editProfile": "编辑资料",
  "settings.agents.admissionStatus": "准入状态",
  "settings.agents.skills": "技能",
  "settings.agents.skillsEmpty": "尚未设置技能标签",
  "settings.agents.globalRoles": "全局角色",
  "settings.agents.globalRolesDescription": "全局角色不受客服组范围限制；组内权限请在客服组页面维护。",
  "settings.agents.grantRoleAria": "授予{role}",
  "settings.agents.revokeRoleAria": "撤销{role}",
  "settings.agents.roleGranted": "已授予",
  "settings.agents.roleNotGranted": "未授予",
  "settings.agents.teamMemberships": "客服组归属",
  "settings.agents.teamMembershipsDescription": "团队角色只对对应客服组范围内的工单生效。",
  "settings.agents.noTeamMemberships": "尚未加入任何客服组。",
  "settings.agents.deactivateDialog.title": "停用成员「{name}」？",
  "settings.agents.deactivateDialog.description": "停用后，该成员会立即失去工作台准入资格，但历史工单、团队归属与角色记录仍会保留。",
  "settings.agents.deactivateDialog.selfWarning": " 这是你当前使用的账号，确认后你将无法继续访问工作台。",
  "settings.agents.deactivateDialog.confirm": "确认停用",
  "settings.agents.profile.title": "编辑业务资料",
  "settings.agents.profile.description": "{name} 的姓名、邮箱和头像来自 IAM；这里只维护 tickbird 内的客服属性。",
  "settings.agents.profile.extensionLabel": "呼叫中心分机",
  "settings.agents.profile.extensionPlaceholder": "例如 8021",
  "settings.agents.profile.skillsLabel": "技能标签",
  "settings.agents.profile.skillsPlaceholder": "支付、退款、英文支持",
  "settings.agents.profile.skillsDescription": "可用逗号、顿号或换行分隔，重复项会自动合并。",
  "settings.agents.profile.save": "保存资料",
  "settings.agents.profile.saving": "正在保存资料",
  "settings.agents.profile.validation.extensionMax": "分机号不能超过 {max} 个字符。",
  "settings.agents.iam.searchAria": "搜索 IAM 员工目录",
  "settings.agents.iamSubjectLabel": "IAM 身份标识",
  "settings.agents.iam.searchPlaceholder": "输入姓名或邮箱…",
  "settings.agents.iam.searchHint": "输入关键词，从公司员工目录中查找人员。",
  "settings.agents.iam.searching": "正在搜索员工目录…",
  "settings.agents.iam.errorTitle": "员工目录暂时不可用",
  "settings.agents.iam.errorDescription": "请稍后重试，不支持手工填写身份标识。",
  "settings.agents.iam.noMatches": "没有找到匹配的员工，请换个关键词。",
  "settings.agents.iam.adding": "正在添加员工",
  "settings.agents.iam.provision": "开通",
  "settings.agents.iam.provisioned": "已开通",
  "settings.agents.iam.provisionedDisabled": "已开通 · 停用",
  "settings.agents.iam.provisionDescription": "只提交 IAM 身份标识，姓名、邮箱和头像会由服务端从员工目录读取。开通后还需要分配客服组或全局角色。",
  "settings.agents.toast.provisioned": "{name} 已开通",
  "settings.agents.toast.profileSaved": "{name} 的业务资料已保存",
  "settings.agents.toast.enabled": "{name} 已启用",
  "settings.agents.toast.disabled": "{name} 已停用",
  "settings.agents.toast.roleGranted": "{name} 的「{role}」已授予",
  "settings.agents.toast.roleRevoked": "{name} 的「{role}」已撤销",

  "settings.ai.title": "AI 智能",
  "settings.ai.description": "工单自动分类、回复建议与摘要的开关及模型参数。",
  "settings.ai.navigation.general": "通用设置",
  "settings.ai.navigation.providers": "AI 提供商",
  "settings.ai.navigation.loadError": "提供商列表加载失败。",
  "settings.ai.navigation.empty": "暂无可配置的 AI 提供商。",
  "settings.ai.navigation.loading": "正在加载 AI 提供商",
  "settings.ai.status.enabled": "已启用",
  "settings.ai.status.configured": "已配置",
  "settings.ai.status.configuredDisabled": "已配置 · 未启用",
  "settings.ai.status.notConfigured": "未配置",
  "settings.ai.loading": "正在加载 AI 设置",
  "settings.ai.automation.toastSaved": "AI 通用设置已保存",
  "settings.ai.automation.validation.confidence": "请输入 0 到 100 之间的整数。",
  "settings.ai.automation.title": "通用设置",
  "settings.ai.automation.description": "控制 AI 自动处理的全局采用规则。",
  "settings.ai.automation.classificationTitle": "自动采用分类建议",
  "settings.ai.automation.classificationDescription": "当 AI 分类建议达到设定置信度时，系统可直接采用建议，低于阈值的结果仍保留给人工确认。",
  "settings.ai.automation.confidenceLabel": "最低置信度",
  "settings.ai.automation.confidenceDescription": "建议从 80% 开始，根据实际准确率逐步调整。",
  "settings.ai.automation.confidenceSliderAria": "最低置信度滑块",
  "settings.ai.automation.alwaysManual": "始终人工确认",
  "settings.ai.automation.highConfidenceOnly": "仅高置信度自动采用",
  "settings.ai.automation.modelHint": "分类、摘要、下一步建议和回复草稿使用的模型，请在左侧选择具体 AI 提供商后配置。",
  "settings.ai.cancelChanges": "取消更改",
  "settings.ai.saveSettings": "保存设置",
  "settings.ai.saving": "保存中…",
  "settings.ai.automation.saving": "正在保存自动化设置",
  "settings.ai.provider.toastSaved": "{name} 设置已保存",
  "settings.ai.provider.viewDocs": "查看文档",
  "settings.ai.provider.capability.classification": "工单分类",
  "settings.ai.provider.capability.summary": "摘要",
  "settings.ai.provider.capability.nextAction": "下一步建议",
  "settings.ai.provider.capability.replyDraft": "回复草稿",
  "settings.ai.provider.configurationRequiredTitle": "完成必填配置后才能启用",
  "settings.ai.provider.configurationRequiredDescription": "请先填写 API Key 和默认模型，再打开“启用”开关。",
  "settings.ai.provider.changedOnlyHint": "仅保存发生变化的字段；密钥不会回显。",
  "settings.ai.provider.saving": "正在保存 AI 设置",
  "settings.ai.provider.customValue": "自定义值",
  "settings.ai.provider.resetPending": "保存后恢复默认",
  "settings.ai.provider.restoreDeploymentDefault": "恢复部署默认值",
  "settings.ai.provider.selectPlaceholder": "请选择",
  "settings.ai.provider.secretConfiguredPlaceholder": "已配置；输入新值即可替换",
  "settings.ai.provider.secretPlaceholder": "输入密钥",
  "settings.ai.provider.hideSecretAria": "隐藏密钥",
  "settings.ai.provider.showSecretAria": "显示密钥",
  "settings.ai.provider.modelPlaceholder": "输入模型 ID 或从列表选择",
  "settings.ai.provider.refreshModelsAria": "刷新模型列表",
  "settings.ai.provider.refreshingModels": "正在刷新模型列表",
  "settings.ai.provider.modelsError": "模型列表暂时不可用，仍可手动输入模型 ID。",
  "settings.ai.provider.saved": "已保存",
  "settings.ai.provider.restoreDefault": "恢复默认",
  "settings.ai.provider.resetDescription": "保存后将清除当前全局覆盖，并恢复部署配置或代码默认值。",
  "settings.ai.provider.validation.required": "请填写{label}。",
  "settings.ai.provider.validation.clearViaReset": "如需清除此值，请使用“恢复默认”。",
  "settings.ai.provider.validation.https": "请输入以 https:// 开头的完整地址。",
  "settings.ai.provider.validation.number": "请输入有效数字。",
  "settings.ai.provider.validation.min": "不能小于 {min}。",
  "settings.ai.provider.validation.max": "不能大于 {max}。",

  "settings.system.title": "系统设置",
  "settings.system.description": "调整工作台级别的通用设置。",
  "settings.placeholder.notFoundTitle": "页面不存在",
  "settings.placeholder.notFoundDescription": "该系统配置页面不存在，请从左侧导航重新进入。",
  "settings.placeholder.contentTitle": "{title}内容区域",
  "settings.placeholder.frameworkOnly": "当前阶段仅搭建系统配置框架。"
}
